var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 97,
  height: 108,
  fill: "none",
  viewBox: "0 0 97 108"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B68061",
  d: "M23.578 36.362c3.195-3.742 11.694-15.658 11.694-15.658 1.25-1.062 4.284-2.751 6.696-1.055 2.456 1.729-.08 6.926-.08 6.926 1.561-1.536 6.52-7.15 9.82-4.128 2.38 2.179.225 4.704.225 4.704s1.938-1.44 4.018.143c2.508 1.912-.336 5.184-.336 5.184l-1.584 2.19s1.644-1.094 3.572.671c1.75 1.602-.648 4.482-.648 4.482l-9.368 12.623c.024 4.247 0 5.822 0 9.263 0 8.446-5.252 9.55-5.252 9.55v13.87l-22.49.048V47.164s-.46-5.895 3.733-10.802"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 33.402,
  height: 62.907,
  x: 38.758,
  y: 4.454,
  fill: "#404040",
  rx: 3.34
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40.428 7.794c0-.923.748-1.67 1.67-1.67H68.82c.922 0 1.67.747 1.67 1.67V64.02a1.67 1.67 0 0 1-1.67 1.67H42.098a1.67 1.67 0 0 1-1.67-1.67z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M58.086 57.897h-5.254a2.384 2.384 0 0 0 0 4.767h5.254a2.384 2.384 0 0 0 0-4.767"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#404040",
  d: "M59.077 7.237H51.84a1.392 1.392 0 0 0 0 2.784h7.237a1.392 1.392 0 0 0 0-2.784"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M58.92 42.31h-6.922a1.028 1.028 0 1 0 0 2.056h6.922a1.028 1.028 0 1 0 0-2.057m5.531 4.419H46.467a1.028 1.028 0 0 0 0 2.056H64.45a1.028 1.028 0 0 0 0-2.056m.001 4.418H46.467a1.028 1.028 0 1 0 0 2.057H64.45a1.028 1.028 0 1 0 0-2.057"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFB34A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.67,
  d: "M58.81 23.64h3.34V20.3"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFB34A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.67,
  d: "M59.789 29.938a6.124 6.124 0 1 1 0-8.66l2.362 2.362"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#B68061",
  d: "M22.072 85.154s-.035-22.09 0-23.87c-.035-5.585 1.146-7.403 5.346-10.965L43.2 37.109s2.921-3.018 5.91-.435c2.537 2.196.973 5.253-.644 6.907L38.86 54.183v7.267s.484 4.683-1.615 6.727c-1.343 1.308-2.75 2.108-3.984 2.464v14.534z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#875232",
  d: "M43.095 39.61a.92.92 0 0 1-.026-1.301l1.188-1.204c.95-.987 2.737-1.186 3.73-.233.99.951 1.021 2.64.068 3.628l-1.398 1.257a.92.92 0 0 1-1.301.025z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF4957",
  d: "M46.327 85.108c.432 0 .782-.279.781-.624l-.039-9.82c0-.345-.352-.624-.784-.623l-27.344.066c-.431.002-.783.283-.781.628l.039 9.82c.002.344.354.62.784.62z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#005641",
  d: "M16.49 82.949a3.34 3.34 0 0 1 3.34-3.34h25.608a3.34 3.34 0 0 1 3.34 3.34v10.02H16.49z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#BFD5CF",
  d: "M90.128 86.845a6.06 6.06 0 0 0 4.221-1.697 5.7 5.7 0 0 0 1.749-4.098 5.7 5.7 0 0 0-1.749-4.098 6.06 6.06 0 0 0-4.221-1.697c-.212 0-.424 0-.653.033l-.53.057-.28-.436a7.96 7.96 0 0 0-3.543-2.981 8.25 8.25 0 0 0-4.654-.551 8.1 8.1 0 0 0-4.178 2.067 7.73 7.73 0 0 0-2.275 3.98l-.144.65h-.67a4.58 4.58 0 0 0-3.106 1.331 4.32 4.32 0 0 0-1.275 3.055c0 1.14.457 2.236 1.275 3.055a4.58 4.58 0 0 0 3.106 1.33zm-75.31-65.134a3.88 3.88 0 0 0 2.757-1.151 3.95 3.95 0 0 0 1.142-2.781 3.95 3.95 0 0 0-1.142-2.78 3.88 3.88 0 0 0-2.757-1.153c-.139 0-.277 0-.427.023l-.346.039-.183-.296a5.26 5.26 0 0 0-2.313-2.023 5.2 5.2 0 0 0-3.04-.374 5.23 5.23 0 0 0-2.728 1.403 5.3 5.3 0 0 0-1.486 2.7l-.094.441h-.437a2.94 2.94 0 0 0-2.029.904 3 3 0 0 0-.833 2.072c0 .774.299 1.518.833 2.073a2.94 2.94 0 0 0 2.029.903z"
})));
export { SvgReload as ReactComponent };